var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof elc_service_config_manager !== "undefined") return resolve();
	__webpack_require__.l("http://localhost:8000/fe-elc-service-config-manager/build/bundle.js", (event) => {
		if(typeof elc_service_config_manager !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "elc_service_config_manager");
}).then(() => (elc_service_config_manager));